import { useRejectedErrorsStore } from '@/entities/error/model/rejectedErrorsStore';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';

const RejectedErrorsReporter = () => {
	const { errorsQueue, removeFromQueue } = useRejectedErrorsStore();
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	useEffect(() => {
		if (errorsQueue.length === 0) {
			return;
		}

		removeFromQueue(errorsQueue);

		for (const item of errorsQueue) {
			const key = enqueueSnackbar(item.message, {
				action: <button onClick={() => closeSnackbar(key)}>Dismiss</button>,
				variant: 'error',
			});
		}
	}, [enqueueSnackbar, closeSnackbar, errorsQueue]);

	return null;
};

export default RejectedErrorsReporter;
